<template>
  <div class="queryResult">
    <b-container class="px-0">
      <b-row class="mx-0">
        <b-col cols="12" class="px-0">
          <div>
            <b-table
              :items="queryResultItem"
              :fields="queryResultFields"
              :no-border-collapse="noCollapse"
              responsive
              class="queryResult-table-detail"
            >
              <template #thead-top="">
                <b-tr>
                  <b-th
                    colspan="5"
                    style="
                      background-color: #4b8c80;
                      color: #ffffff;
                      border-color: #4b8c80;
                      font-family: 'dfyuanstd-w7';
                      font-size: 1.125rem;
                    "
                  >
                    <span>查詢結果</span>
                  </b-th>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "queryResult",
  data() {
    return {
      noCollapse: false,
    };
  },
  computed: {
    ...mapGetters({
      queryResultFields: "queryResult/get_queryResultFields",
      queryResultItem: "queryResult/get_queryResultItem",
    }),
  },
};
</script>

<style lang="scss">
.queryResult-table-detail th,
.queryResult-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle!important;
}
.queryResult-table-detail th:first-child,
.queryResult-table-detail td:first-child {
  border-left: 1px solid;
}
.queryResult-table-detail {
  margin-bottom: 0px;
}
.queryResult-table-detail thead th {
  color: #000000;
  background-color: #cccccc;
}
.queryResult-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.queryResult-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/queryResult.vue